import { Paper, Stack, useTheme } from '@mui/material';
import { ProfileVisitsHistoryContent } from 'src/sections/@dashboard/visit/components/ProfileVisitsHistoryContent';

export default function ProfileTabsVisitsHistoryPage() {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: 2,
        boxShadow: theme.customShadows.z8,
        height: 1,
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px' }}>
        <ProfileVisitsHistoryContent />
      </Stack>
    </Paper>
  );
}
